import { notificationsActionTypes } from "./actions";

export const notificationCenter = (
  state = {
    open: false,
    message: "",
    type: "",
  },
  action,
) => {
  switch (action.type) {
    case notificationsActionTypes.addMessageNotificationCenter:
      return {
        ...state,
        open: true,
        message: action.payload.message,
        type: action.payload.type,
      };
    case notificationsActionTypes.closeNotificationCenter:
      return {
        ...state,
        open: false,
      };
    default:
      return state;
  }
};
